






































































import { Component, Vue } from 'vue-property-decorator';
import PrivilegeList from './privileges.vue';
import PasswordDialog from './password.vue';

@Component({ components: { PasswordDialog, PrivilegeList } })
export default class User extends Vue {
    // SOURCE: https://github.com/vuejs/vue-class-component/issues/94
    // TODO: use actual type
    public $refs!: {
        passwordDialog: any;
        form: any;
    };

    private user = { ...this.$store.getters.user };
    private privileges = this.$store.getters.privileges; // PRIVILEGES;
    private passwordRule = this.user.PASSWORTRULE || '';
    private showPasswordDialog = false;

    // TODO: create deep compare helper ..
    get didFormChanged() {
        return (
            this.user.FIRSTNAME !== this.$store.getters.user.FIRSTNAME ||
            this.user.FAMILYNAME !== this.$store.getters.user.FAMILYNAME ||
            this.user.EMAIL !== this.$store.getters.user.EMAIL
        );
    }

    get darkMode() {
        return this.$store.getters.darkMode;
    }

    set darkMode(val: number) {
        this.$store.commit('updateDarkMode', val);
    }

    private hndlSave() {
        if (this.$refs.form.validate()) {
            this.$store.dispatch('saveUser', { ...this.user });
        }
    }

    private hndlReset() {
        this.user = { ...this.$store.getters.user };
    }

    private hndlPasswordRef() {
        this.$refs.passwordDialog.showDialog();
    }

    private async hndlPasswordChangedRef(data: any) {
        const rc = await this.$store.dispatch('changePassword', {
            OLDPASSWORD: data.oldPassword,
            PASSWORD: data.newPassword1,
            PASSWORD2: data.newPassword2,
        });

        if (rc.code === 0) this.$refs.passwordDialog.closeDialog();
    }

    private hndlPasswordModel() {
        this.showPasswordDialog = true;
    }

    private async hndlPasswordChangedModel(data: any) {
        const rc = await this.$store.dispatch('changePassword', {
            OLDPASSWORD: data.oldPassword,
            PASSWORD: data.newPassword1,
            PASSWORD2: data.newPassword2,
        });

        if (rc.code === 0) this.showPasswordDialog = false;
    }
}
